import React from "react";
import Select from "react-select";
import Option from "./Option";
import "./Typeface.css";

class SelectTypeface extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.selectedValue,
    };
  }

  handleSelectFont = (value) => {
    const fonts = this.props.allFonts,
      selectedFont = fonts[value];

    this.setState({ value });
    this.props.handleFontChange(selectedFont);
  };

  render() {
    const categories = this.props.fontCategories,
      fonts = this.props.allFonts,
      fontCategories = Object.values(categories);

    let optionsArray = [];

    // Sort categories by weight
    fontCategories.sort((a, b) => {
      return a.weight - b.weight;
    });

    // Push categories as disabled options in the array, to act as optgroup headers
    fontCategories.map((category) => {
      optionsArray.push({
        name: category.name,
        id: category.id,
        fonts: category.fonts,
        type: "category",
        disabled: true,
      });

      // Get all fonts belonging to the category
      let fontList = category.fonts.map((id) => {
        return fonts[id];
      });

      // Sort fonts alphabetically
      fontList.sort(function (a, b) {
        const nameA = a.name.toUpperCase(); // ignore upper and lowercase
        const nameB = b.name.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });

      // Push the fonts as options to the array, following the disabled category option
      fontList.map((font) => {
        optionsArray.push({
          name: font.name,
          value: font.id,
          label: font.name,
          id: font.id,
          is_active: font.is_active,
          thumbnail: font.thumbnail,
          type: "font",
          disabled: false,
          selected: this.state.value,
          handleSelectFont: this.handleSelectFont,
        });
        return {};
      });

      return {};
    });

    return (
      <div className="tool__selectfont select-typeface">
        <h4 className="dropdown__title">Typeface</h4>

        <Select
          options={optionsArray}
          optionComponent={Option}
          value={this.state.value}
          placeholder={this.props.font.name}
          clearable={false}
          onChange={this.handleSelectFont}
          simpleValue
        />
      </div>
    );
  }
}

export default SelectTypeface;
